module.exports = __webpack_public_path__ + "img/img-3.696b4438.svg";